import { useMediaQuery } from "react-responsive"

export const useBreakpoints = () => {
    const breakpoints = {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
    }
    
    return {
        sm: useMediaQuery({ maxWidth: breakpoints.sm }),
        md: useMediaQuery({ maxWidth: breakpoints.md }),
        lg: useMediaQuery({ maxWidth: breakpoints.lg }),
        xl: useMediaQuery({ maxWidth: breakpoints.xl }),
    }
}